var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{attrs:{"title":"Recetas que hacen uso del articulo","hide-footer":"","id":"article-used-in-recipes"}},[(!_vm.loading)?_c('div',[_c('b-table',{staticClass:"s-2 b-r-1",attrs:{"head-variant":"dark","fields":_vm.fields,"items":_vm.items}})],1):_c('div',{staticClass:"all-center-md"},[_c('b-spinner',{attrs:{"variant":"primary"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }